import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import { useHistory, useParams } from "react-router";
import PaymentService from "../../../Services/PaymentService";
import { Base64 } from "js-base64";
import { BsPatchCheck } from "react-icons/bs";
import moment from "moment";
import { message, Modal } from "antd";
import AppointmentService from "../../../Services/AppointmentService";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { getLoaderState } from "../../../Redux/actions/CommonActions";
import { useDispatch } from "react-redux";

const PaymentInitiation = () => {
  const params = useParams();
  const history = useHistory();
  const [status, setStatus] = useState();
  const dispatch = useDispatch();

  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    getpaymentStatus();
  }, [params]);
  const getpaymentStatus = async () => {
    dispatch(getLoaderState(true));
    try {
      let decodedValues = Base64.decode(params.transactionId);
      let splitValues = decodedValues.split("|");

      const data = {
        transactionId: splitValues[0],
        serviceTransId: splitValues[3],
        patientId: splitValues[1],
        userId: splitValues[2],
        account_Id: splitValues[4],
        clinic_Id: splitValues[5],
      };

      const result = await PaymentService.getTransactionStatus(data);
      if (result) {
        setStatus(result?.data);
      }

      const appointmentRes = await AppointmentService.GetAppointmentId(
        data.serviceTransId
      );

      let appointmentUpdate = {
        appointmentId: appointmentRes.data[0]?.appointmentId,
        meetingLink: appointmentRes.data[0]?.meetingLink,
        mobile: appointmentRes.data[0]?.mobile,
        email: appointmentRes.data[0]?.email,
        id: appointmentRes.data[0]?.id,
        patientId: appointmentRes.data[0]?.patientId,
        status: 1,
        paymentReceived: "Y",
        userId: loginResultObject.user?.userId,
        createdBy: loginResultObject.user?.userId,
        modifiedBy: loginResultObject.user?.userId,
      };
      await AppointmentService.AppointmentUpdate(appointmentUpdate);
    } catch (error) {
      console.error("Error in getpaymentStatus:", error);
      message.error(
        "Something went wrong while processing the payment. Please try again or contact support."
      );
    } finally {
      dispatch(getLoaderState(false));
      setTimeout(() => {
        history.push(APP_ROUTES.DASHBOARD);
      }, 3000);
    }
  };

  const convertUTCDateLocal = (utcDate, format = "DD/MM/YYYY, HH:mm:ss") => {
    if (!utcDate) return "";
    const localDate = moment.utc(utcDate).local();
    return localDate.format(format);
  };

  const handlepayment = () => {
    history.push(APP_ROUTES.DASHBOARD);
  };

  return (
    <Layouts>
      <div>
        {status?.code == "PAYMENT_SUCCESS" ? (
          <div>
            <div className="bg-white p-6 rounded-xl shadow-lg mt-10 max-w-sm mx-auto border">
              <div className="text-center">
                <div className="bg-[#E6F2EE] w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <div className="bg-brand-primaryColor w-7 h-7 rounded-full mx-auto flex items-center justify-center">
                    <BsPatchCheck className="text-white" />
                  </div>
                </div>
                <div>
                  <h2 className="text-xl text-gray-600 font-medium mb-2">
                    Payment Success!
                  </h2>
                  <p className=" mb-4 font-bold">₹ {status?.paidAmount}</p>
                </div>
              </div>
              <div className="border border-b-2"></div>
              <div className="m-3 ">
                <div className="flex justify-between ">
                  <p className="text-gray-600 font-medium text-base">
                    Transaction ID
                  </p>
                  <p className="text-gray-600 font-medium text-base">
                    {status?.transactionId}
                  </p>
                </div>
                <div className="flex justify-between mt-2">
                  <p className="text-gray-600 font-medium text-base">
                    Payment Time
                  </p>
                  <p className="text-gray-600 font-medium text-base">
                    {convertUTCDateLocal(status?.paidDate)}
                  </p>
                </div>
                <div className="">
                  <button
                    onClick={() => handlepayment()}
                    className="text-center border rounded-lg mt-5 w-full p-2 bg-brand-primaryColor text-white text-lg font-medium"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </Layouts>
  );
};

export default PaymentInitiation;
